import AsyncStorage from '@react-native-async-storage/async-storage';

import type { FavoriteEntityType } from '@/lib/supabase/types';

/**
 * Buffer for the FIRST-RUN picker that runs BEFORE sign-in. The guest picks the
 * teams / competitions / players they follow with no account yet; we stash the
 * choices here, then apply them to user_favorites the moment they sign in (in
 * the welcome screen's finalize step). A temporary buffer only - cleared on use.
 */
const KEY = 'tashkeela.pendingOnboarding';

export interface PendingFavorite {
  type: FavoriteEntityType;
  id: string;
}

export interface PendingOnboarding {
  favorites: PendingFavorite[];
}

export async function savePendingOnboarding(data: PendingOnboarding): Promise<void> {
  try {
    await AsyncStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // Non-fatal: the user just lands on sign-in without pre-applied follows.
  }
}

export async function loadPendingOnboarding(): Promise<PendingOnboarding | null> {
  try {
    const value = await AsyncStorage.getItem(KEY);
    if (!value) return null;
    const parsed = JSON.parse(value) as PendingOnboarding;
    return Array.isArray(parsed.favorites) ? parsed : null;
  } catch {
    return null;
  }
}

export async function clearPendingOnboarding(): Promise<void> {
  try {
    await AsyncStorage.removeItem(KEY);
  } catch {
    // Non-fatal.
  }
}
